import { call, put, takeEvery } from "redux-saga/effects";

// Calender Redux States
import {
  ADD_NEW_APPOINTMENTS,
  DELETE_APPOINTMENTS,
  CONFIRM_APPOINTMENTS,
  GET_APPOINTMENTS,
  GET_APPOINTMENTS_DETAILS,
  UPDATE_APPOINTMENTS,
  ADD_REMARKS_APPOINTMENTS,
} from "./actionTypes.js";

import {
  addAppointmentsFail,
  addAppointmentsSuccess,
  deleteAppointmentsFail,
  deleteAppointmentsSuccess, 
  confirmAppointmentsFail,
  confirmAppointmentsSuccess,
  getAppointmentsDetailsFail,
  getAppointmentsDetailsSuccess,
  getAppointmentsFail,
  getAppointmentsSuccess,
  updateAppointmentsFail,
  updateAppointmentsSuccess,
  addRemarksAppointmentsSuccess,
  addRemarksAppointmentsFail,
} from "./actions.js";

import {
  addNewAppointments,
  appointmentsDetailsApi,
  appointmentsListingApi,
  delAppointments,
  confirmAppointment,
  updateAppointments,
  addRemarksAppointment,
} from "./appointmentsApi.js";

function* fetchAppointments({ payload: length, sort, page, name, date, status, patientID, sort_by }) {
  try {
    const response = yield call(appointmentsListingApi, length, sort, page, name, date, status, patientID, sort_by)
    yield put(getAppointmentsSuccess(response))
  } catch (error) {
    yield put(getAppointmentsFail(error))
  }
}
function* fetchAppointmentsDetails({ payload: id }) {
  try {
    const response = yield call(appointmentsDetailsApi, id)
    yield put(getAppointmentsDetailsSuccess(response))
  } catch (error) {
    yield put(getAppointmentsDetailsFail(error))
  }
}

function* onAddNewAppointments({ payload: appointments }) {
  try {
    const response = yield call(addNewAppointments, appointments)
    yield put(addAppointmentsSuccess(response))
  } catch (error) {
    yield put(addAppointmentsFail(error))
  }
}

function* onUpdateAppointments({ payload: id, appointments }) {
  try {
    const response = yield call(updateAppointments, id, appointments)
    yield put(updateAppointmentsSuccess(response))
  } catch (error) {
    yield put(updateAppointmentsFail(error))
  }
}

function* onDelAppointments({ payload: id, msg }) {
  try {
    const response = yield call(delAppointments, id, msg)
    yield put(deleteAppointmentsSuccess(response))
  } catch (error) {
    yield put(deleteAppointmentsFail(error))
  }
}

function* onConfirmAppointments({ payload: id, appointments }) {
  try {
    const response = yield call(confirmAppointment, id, appointments)
    yield put(confirmAppointmentsSuccess(response))
  } catch (error) {
    yield put(confirmAppointmentsFail(error))
  }
}

function* onAddRemarksAppointment({ payload: id, appointments }) {
  try {
    const response = yield call(addRemarksAppointment, id, appointments)
    yield put(addRemarksAppointmentsSuccess(response))
  } catch (error) {
    yield put(addRemarksAppointmentsFail(error))
  }
}


function* AppointmentsSaga() {
  yield takeEvery(GET_APPOINTMENTS, fetchAppointments)
  yield takeEvery(GET_APPOINTMENTS_DETAILS, fetchAppointmentsDetails)
  yield takeEvery(ADD_NEW_APPOINTMENTS, onAddNewAppointments)
  yield takeEvery(UPDATE_APPOINTMENTS, onUpdateAppointments)
  yield takeEvery(DELETE_APPOINTMENTS, onDelAppointments)
  yield takeEvery(CONFIRM_APPOINTMENTS, onConfirmAppointments)
  yield takeEvery(ADD_REMARKS_APPOINTMENTS, onAddRemarksAppointment)
}

export default AppointmentsSaga
